<div class="upload-invoices-cover-sheet d-flex flex-column align-items-center">
    <h2
        class="h1 text-center"
        i18n="Heading for the 'cover sheet' screen of the 'upload invoices' flow"
    >
        First, tell us about the invoices you're submitting.
    </h2>

    <div class="cover-sheet-body row">
        <div class="cover-sheet-left col-lg-8">
            <form class="cover-sheet-form" [formGroup]="coverSheetFormGroup">
                <fieldset class="cover-sheet-form-amounts">
                    <legend
                        class="cover-sheet-form-amounts-title h3"
                        i18n="
                            Title of the form requesting basic details about the invoices being
                            uploaded
                        "
                    >
                        About Your Invoices
                    </legend>
                    <lsq-currency-input
                        formControlName="totalAmount"
                        [label]="coverSheetFormAmountsTotalLabel"
                        [name]="'cover-sheet-form-amounts-total'"
                        [group]="coverSheetFormGroup"
                        [floatLabel]="true"
                    >
                    </lsq-currency-input>
                    <lsq-input
                        formControlName="count"
                        [maxLength]="6"
                        [label]="coverSheetFormAmountsCountLabel"
                        [name]="'cover-sheet-form-amounts-count'"
                        [group]="coverSheetFormGroup"
                        [digitsOnly]="true"
                        [floatLabel]="true"
                        [type]="'number'"
                    >
                    </lsq-input>
                </fieldset>

                <ng-container *ngIf="showPrivilegedFundingMethodOptions">
                    <div class="funding-method-section">
                        <fieldset class="cover-sheet-form-funding-method">
                            <legend
                                class="cover-sheet-form-funding-method-title h3"
                                i18n="
                                    Label for the radio group allowing the user to select how their
                                    funds should be disbursed
                                "
                            >
                                Funding Method
                            </legend>
                            <div class="cover-sheet-form-funding-method-radio-list">
                                <div class="cover-sheet-form-funding-method-radio-list-item">
                                    <lsq-radio
                                        i18n-label="
                                            Description of the funding method by which money is
                                            added to the company's available funds rather than being
                                            disbursed
                                        "
                                        label="Funds from submitted invoices will be added to your Available Funds"
                                        [name]="'fundingMethod'"
                                        [id]="'invoice-funding-method-add-to-available-funds'"
                                        [value]="invoiceFundingMethod.NoDisbursement"
                                        [group]="coverSheetFormGroup"
                                        formControlName="fundingMethod"
                                    >
                                    </lsq-radio>
                                    <div
                                        *ngIf="
                                            defaultFundingMethod ===
                                            invoiceFundingMethod.NoDisbursement
                                        "
                                        class="cover-sheet-form-funding-method-default-label"
                                    >
                                        {{ defaultFundingMethodCopyI18n }}
                                    </div>
                                </div>
                                <div class="cover-sheet-form-funding-method-radio-list-item">
                                    <lsq-radio
                                        i18n-label="
                                            Description of the funding method by which funds are
                                            immediately disbursed
                                        "
                                        label="Funds from submitted invoices will be disbursed"
                                        [name]="'fundingMethod'"
                                        [id]="'invoice-funding-method-disburse-submitted'"
                                        [value]="invoiceFundingMethod.InvoiceBatchDisbursement"
                                        [group]="coverSheetFormGroup"
                                        formControlName="fundingMethod"
                                    >
                                    </lsq-radio>
                                    <div
                                        *ngIf="
                                            defaultFundingMethod ===
                                            invoiceFundingMethod.InvoiceBatchDisbursement
                                        "
                                        class="cover-sheet-form-funding-method-default-label"
                                    >
                                        {{ defaultFundingMethodCopyI18n }}
                                    </div>
                                </div>
                                <div class="cover-sheet-form-funding-method-radio-list-item">
                                    <lsq-radio
                                        i18n-label="
                                            Description of the funding method by which all the
                                            company's available funds are disbursed, including those
                                            from this funding
                                        "
                                        label="Funds from both submitted invoices and Available Funds will be disbursed"
                                        [name]="'fundingMethod'"
                                        [id]="'invoice-funding-method-disburse-all'"
                                        [value]="
                                            invoiceFundingMethod.InvoiceBatchAndAvailabilityDisbursement
                                        "
                                        [group]="coverSheetFormGroup"
                                        formControlName="fundingMethod"
                                    >
                                    </lsq-radio>
                                    <div
                                        *ngIf="
                                            defaultFundingMethod ===
                                            invoiceFundingMethod.InvoiceBatchAndAvailabilityDisbursement
                                        "
                                        class="cover-sheet-form-funding-method-default-label"
                                    >
                                        {{ defaultFundingMethodCopyI18n }}
                                    </div>
                                </div>
                                <div class="cover-sheet-form-funding-method-radio-list-item">
                                    <lsq-radio
                                        i18n-label="
                                            Description of the funding method by which the user
                                            enters a specific amount to be immediately disbursed
                                        "
                                        label="Enter a specific funding amount"
                                        [name]="'fundingMethod'"
                                        [id]="'invoice-funding-method-enter-amount'"
                                        [value]="invoiceFundingMethod.SpecificAmount"
                                        [group]="coverSheetFormGroup"
                                        formControlName="fundingMethod"
                                    >
                                    </lsq-radio>
                                    <div
                                        *ngIf="
                                            defaultFundingMethod ===
                                            invoiceFundingMethod.SpecificAmount
                                        "
                                        class="cover-sheet-form-funding-method-default-label"
                                    >
                                        {{ defaultFundingMethodCopyI18n }}
                                    </div>
                                    <div
                                        *ngIf="
                                            coverSheetFormGroup.get('fundingMethod').value ===
                                            invoiceFundingMethod.SpecificAmount
                                        "
                                        class="cover-sheet-form-funding-method-enter-amount"
                                    >
                                        <lsq-currency-input
                                            i18n-label="
                                                Prompts the user to enter a specific amount to be
                                                immediately disbursed
                                            "
                                            label="Enter desired funding amount"
                                            name="fundingMethodSpecificAmount"
                                            formControlName="customFundingAmount"
                                            [floatLabel]="true"
                                            [group]="coverSheetFormGroup"
                                            [autoFocus]="true"
                                        >
                                        </lsq-currency-input>
                                    </div>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset class="cover-sheet-form-amounts cover-sheet-form-bank-account">
                            <lsq-select
                                *ngIf="shouldShowBankAccountField()"
                                i18n-label="
                                    Prompts the user to select the bank account to which funds will
                                    be disbursed
                                "
                                label="Select Account"
                                name="bankAccountKeyForDisbursement"
                                formControlName="bankAccountKeyForDisbursement"
                                [innerLabel]="true"
                                [options]="availableBankAccountsForFundingSelectOptions"
                            >
                            </lsq-select>
                        </fieldset>
                    </div>
                </ng-container>

                <div
                    *ngIf="!showPrivilegedFundingMethodOptions"
                    class="cover-sheet-form-funding-method"
                >
                    <h3
                        class="cover-sheet-form-funding-method-title"
                        i18n="
                            Label for the radio group allowing the user to select how their funds
                            should be disbursed
                        "
                    >
                        Funding Method
                    </h3>
                    <p
                        class="cover-sheet-form-funding-method-subtitle"
                        i18n="
                            Description of the default funding method by which money is added to the
                            company's available funds rather than being disbursed
                        "
                    >
                        Funds from submitted invoices will be added to your Available Funds
                    </p>
                </div>
            </form>
        </div>

        <div
            class="cover-sheet-right cover-sheet-invoice-summary col-lg-4"
            [ngClass]="{ disabled: !coverSheetFormGroup.valid }"
        >
            <h3 class="cover-sheet-invoice-summary-title d-flex">
                <span
                    i18n="Title of the form in which an invoice summary can optionally be uploaded"
                >
                    Optional Invoice Summary
                </span>
                <lsq-icon-popover
                    i18n-text="Describes why the invoice summary is useful"
                    text="The Invoice Summary is a detailed listing of the invoices you are submitting to LSQ. If we find any differences between the Invoice Summary and submitted invoices, this will allow us to reconcile on your behalf to ensure you get funded quickly."
                >
                </lsq-icon-popover>
            </h3>
            <p
                class="cover-sheet-invoice-summary-subtitle"
                i18n="Describes what an invoice summary is"
            >
                The Invoice Summary is a detailed listing of the invoices you are submitting to LSQ.
            </p>
            <!-- TODO(dmayer): Uncomment once we have an actual template file to download
                <p>
                    <a class="cover-sheet-invoice-summary-download-template-link"
                        (click)="downloadInvoiceSummaryTemplate()"
                        href="javascript:void(0)">
                        Download Template
                    </a>
                </p>
            -->
            <ng-template
                #invoiceSummaryUpload
                let-invoiceSummaryFileUpload="invoiceSummaryFileUpload"
            >
                <div
                    *ngIf="!!invoiceSummaryFileUpload"
                    class="cover-sheet-invoice-summary-upload"
                    [ngStyle]="{
                        opacity:
                            invoiceSummaryFileUpload.isUploadStatusComplete ||
                            invoiceSummaryFileUpload.hasFailed
                                ? 1
                                : 0.5
                    }"
                >
                    <div class="cover-sheet-invoice-summary-upload-main">
                        <div class="cover-sheet-invoice-summary-upload-info">
                            <lsq-icon
                                *ngIf="!invoiceSummaryFileUpload.hasFailed"
                                [ngStyle]="{
                                    opacity: invoiceSummaryFileUpload.isUploadStatusComplete ? 1 : 0
                                }"
                                [type]="icons.Checkmark"
                                [color]="color.Green"
                            >
                            </lsq-icon
                            ><!-- This comment makes sure a space isn't rendered in the DOM.
                        --><lsq-icon
                                *ngIf="invoiceSummaryFileUpload.hasFailed"
                                [type]="icons.CloseSmall"
                                [color]="color.Red"
                            >
                            </lsq-icon
                            ><!-- This comment makes sure a space isn't rendered in the DOM.
                        --><span class="cover-sheet-invoice-summary-upload-filename text-truncate">
                                {{ invoiceSummaryFileUpload?.name
                                }}<!--
                            --><span
                                    *ngIf="invoiceSummaryFileUpload.hasFailed"
                                    class="failed-message"
                                    >&nbsp;(Failed)</span
                                >
                            </span>
                        </div>
                        <div class="cover-sheet-invoice-summary-upload-actions">
                            <a
                                *ngIf="invoiceSummaryFileUpload.isUploadStatusComplete"
                                class="cover-sheet-invoice-summary-upload-view"
                                href="javascript:void(0)"
                                (click)="showInvoiceSummaryPreviewModal()"
                                i18n="
                                    Button prompting the user to view the invoice summary they just
                                    uploaded
                                "
                            >
                                View
                            </a>
                            <lsq-button
                                *ngIf="
                                    invoiceSummaryFileUpload.isUploadStatusComplete ||
                                    invoiceSummaryFileUpload.hasFailed
                                "
                                appearance="transparent"
                                (buttonClick)="removeInvoiceSummaryUpload()"
                            >
                                <lsq-icon [type]="icons.Trash" [color]="color.GrayDark"> </lsq-icon>
                                <span
                                    class="sr-only"
                                    i18n="
                                        Button prompting the user to remove the invoice summary they
                                        just uploaded
                                    "
                                >
                                    Remove
                                </span>
                            </lsq-button>
                        </div>
                    </div>
                    <div
                        *ngIf="invoiceSummaryFileUpload.uploading"
                        class="cover-sheet-invoice-summary-upload-progress"
                    >
                        <lsq-progress-bar
                            [value]="invoiceSummaryFileUpload.progressPercentage"
                            [danger]="invoiceSummaryFileUpload.hasFailed"
                            [skinny]="true"
                        >
                        </lsq-progress-bar>
                    </div>
                </div>
            </ng-template>
            <ng-container
                *ngTemplateOutlet="
                    invoiceSummaryUpload;
                    context: {
                        invoiceSummaryFileUpload: uploadInvoicesService.invoiceSummaryFileUpload
                    }
                "
            >
            </ng-container>
            <div class="cover-sheet-invoice-summary-file-select file-select-group">
                <lsq-button
                    *ngIf="!uploadInvoicesService.invoiceSummaryFileUpload"
                    appearance="secondary"
                    [disabled]="!coverSheetFormGroup.valid"
                    (buttonClick)="handleUploadInvoiceSummaryClick()"
                    i18n="Button prompting the user to upload an invoice summary"
                >
                    Upload Invoice Summary
                </lsq-button>
            </div>
        </div>
    </div>
</div>
